import React from 'react';
import classNames from 'classnames';
import {Cell} from '../Cell/Cell';
import {LayoutComponentProps} from '../../../types/app-types';
import {ProductPageSlotIds} from '../../../constants';
import s from './SimpleLayout.scss';
import {SlotsPlaceholder} from '@wix/widget-plugins-ooi';
import {ProductPrice} from '../../ProductPrice/ProductPrice';
import {ProductDiscountName} from '../../ProductDiscountName/ProductDiscountName';
import {ProductPaymentBreakdown} from '../../ProductPaymentBreakdown/ProductPaymentBreakdown';
import {DetailsPlaceholder} from '../../Placeholders/DetailsPlaceholder';
import {ProductOptions} from '../../ProductOptions/ProductOptions';
import {ProductPageButtonsContainer} from '../../ProductPageButtonsContainer/ProductPageButtonsContainer';
import {ProductSocial} from '../../ProductSocial/ProductSocial';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';

export const SimpleLayoutRightSection: React.FunctionComponent<LayoutComponentProps> = ({globals}) => {
  const {product, hasDiscountName, hasPaymentOptionsBreakdown} = globals;
  const {renderProductPageSlots} = globals.experiments ?? {};
  const isPluginInstalledInDetails3Slot = !!globals.slots?.[ProductPageSlotIds.ProductPageDetails3];

  return (
    <section className={s.rightSection}>
      <ConditionalRender by="productPage_productPrice">
        <Cell>
          <ProductPrice />
        </Cell>
      </ConditionalRender>
      {renderProductPageSlots && (
        <Cell className={classNames({[s.productPageSlot]: isPluginInstalledInDetails3Slot})}>
          <SlotsPlaceholder slotId={ProductPageSlotIds.ProductPageDetails3} />
        </Cell>
      )}

      {hasDiscountName && (
        <ConditionalRender by="productPage_showDiscountName">
          <Cell>
            <ProductDiscountName name={product.itemDiscount.discountRuleName} />
          </Cell>
        </ConditionalRender>
      )}

      {hasPaymentOptionsBreakdown && (
        <ConditionalRender by="productPage_paymentOptionsBreakdown">
          <Cell>
            <ProductPaymentBreakdown />
          </Cell>
        </ConditionalRender>
      )}

      <Cell>
        <DetailsPlaceholder />
      </Cell>
      <Cell>
        <ProductOptions />
        <ProductPageButtonsContainer />
      </Cell>
      <ConditionalRender by="productPage_socialNetworks">
        <Cell className={s.social}>
          <ProductSocial />
        </Cell>
      </ConditionalRender>
    </section>
  );
};
